import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// The established claim-verification shell; existing Login/FFLClaims CSS remains authoritative.
export default function EmailVerificationDialog({ title, children }) {
    return <div className="modal-overlay">
        <div className="modal modal-claim" role="dialog" aria-modal="true" aria-label={title}>
            <h2><span className="titleIcon"><FontAwesomeIcon icon="envelope-circle-check" /></span>&nbsp;{title}</h2>
            {children}
        </div>
    </div>;
}
